import type { IGetStrategyLevelInfoResponse } from '@/Module/Grade/Model/ApiModel';
import type { ILevel, IPointer } from '@/Module/Grade/Model/DataModel';
import { FieldType, StrategyType } from '@/Module/Grade/Model/Enum';

export const prepareLevelList = (rawData: IGetStrategyLevelInfoResponse[]): ILevel[] => {
  if (!rawData || rawData.length === 0) {
    return [];
  }

  const menuList: ILevel[] = [];

  const findOrCreate = (list: ILevel[], id: string, name: string, pointer?: IPointer): ILevel => {
    let item = list.find(child => child.id === id);
    if (!item) {
      item = { id, name, child: [], ...(pointer ? { pointer } : {}) };
      list.push(item);
    }
    return item;
  };

  rawData.forEach(item => {
    const { strategy_type: strategyType, seo_info: seoInfo } = item;
    const level = item.education_level?.level;
    const grade = item.education_level?.grade;
    const field = item.education_level?.field;

    if (!strategyType || !level || !grade || !field) return;

    const strategyIdPart = `S${strategyType.id}`;
    const levelIdPart = `L${level.id}`;
    const gradeIdPart = `G${grade.id}`;
    const fieldIdPart = `F${field.id}`;

    const pointerBase = {
      strategyId: strategyType.id,
      levelId: level.id,
      gradeId: grade.id,
      fieldId: field.id,
    };

    if (strategyType.id === StrategyType.TEXT_BOOK) {
      const levelId = `${strategyIdPart}${levelIdPart}`;
      const levelNode = findOrCreate(menuList, levelId, level.name ?? '', pointerBase);

      const gradeId = `${levelNode.id}${gradeIdPart}`;
      const gradeNode = findOrCreate(levelNode.child!, gradeId, grade.name ?? '', pointerBase);

      if (field.id === FieldType.GENERAL_STUDIES) {
        gradeNode.id = `${gradeNode.id}${fieldIdPart}`;
        gradeNode.seoUrlSlug = seoInfo?.seo_url_slug ?? '';
      } else {
        const fieldNode = findOrCreate(gradeNode.child!, `${gradeNode.id}${fieldIdPart}`, field.name ?? '', pointerBase);
        fieldNode.seoUrlSlug = seoInfo?.seo_url_slug ?? '';
      }
    } else if (strategyType.id === StrategyType.ENTRANCE_EXAM) {
      const strategyNode = findOrCreate(menuList, strategyIdPart, strategyType.title ?? '', pointerBase);

      const fieldId = `${strategyNode.id}${levelIdPart}${fieldIdPart}`;
      const fieldNode = findOrCreate(strategyNode.child!, fieldId, field.name ?? '', pointerBase);

      const gradeId = `${fieldNode.id}${gradeIdPart}`;
      const gradeNode = findOrCreate(fieldNode.child!, gradeId, grade.name ?? '', pointerBase);

      gradeNode.seoUrlSlug = seoInfo?.seo_url_slug ?? '';
    } else {
      const strategyNode = findOrCreate(menuList, strategyIdPart, strategyType.title ?? '', pointerBase);

      const gradeId = `${strategyNode.id}${levelIdPart}${gradeIdPart}`;
      const gradeNode = findOrCreate(strategyNode.child!, gradeId, grade.name ?? '', pointerBase);

      if (field.id === FieldType.GENERAL_STUDIES) {
        gradeNode.seoUrlSlug = seoInfo?.seo_url_slug ?? '';
      } else {
        const fieldNode = findOrCreate(gradeNode.child!, `${gradeNode.id}${fieldIdPart}`, field.name ?? '', pointerBase);
        fieldNode.seoUrlSlug = seoInfo?.seo_url_slug ?? '';
      }
    }
  });

  const cleanEmptyChildren = (list: ILevel[]): ILevel[] => {
    return list.map(({ child, ...rest }) => ({
      ...rest,
      ...(child && child.length > 0 ? { child: cleanEmptyChildren(child) } : {}),
    }));
  };

  return cleanEmptyChildren(menuList);
};
